import { render, staticRenderFns } from "./SnowEffect.vue?vue&type=template&id=247ced3f"
import script from "./SnowEffect.vue?vue&type=script&lang=js"
export * from "./SnowEffect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports